<template>
    <div class="rag-strategy-menu">
      <!-- Current Strategy as Menu Trigger -->
      <v-menu
        v-model="isMenuOpen"
        :close-on-content-click="false"
        :nudge-width="150"
        offset-y
      >
        <template v-slot:activator="{ on, attrs }">
          <v-chip
            v-bind="attrs"
            v-on="on"
            :color="strategyColor"
            :text-color="strategyTextColor"
            small
            class="strategy-chip"
          >
            <v-icon left x-small>{{ ragStrategyIcon }}</v-icon>
            {{ currentStrategy }}
            <v-icon right x-small>mdi-chevron-down</v-icon>
          </v-chip>
        </template>

        <v-card>
          <v-list>
            <v-list-item-group>
              <v-list-item
                v-for="strategy in ragStrategies"
                :key="strategy.value"
                @click="handleStrategySelect(strategy)"
                :disabled="strategy.value === 'ecrag'"
              >
                <v-list-item-icon>
                  <v-icon>{{ strategy.icon }}</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title>{{ strategy.text }}</v-list-item-title>
                  <v-list-item-subtitle v-if="strategy.value === 'ecrag'">
                    Coming soon (focused podcasts)
                  </v-list-item-subtitle>
                  <v-list-item-subtitle v-if="strategy.value === 'llm_passthrough'">
                    2-3 min podcasts without sources
                  </v-list-item-subtitle>
                  <v-list-item-subtitle v-if="strategy.value === 'web_search'">
                    4-5 min podcasts with sources
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-card>
      </v-menu>
    </div>
  </template>

  <script>
  export default {
    name: 'RAGStrategyMenu',
    props: {
      initialStrategy: {
        type: String,
        default: 'llm_passthrough'
      }
    },
    data() {
      return {
        isMenuOpen: false,
        rag_strategy: this.initialStrategy,
        ragStrategies: [
          { value: 'llm_passthrough', text: 'LLM', icon: 'mdi-molecule' },
          { value: 'web_search', text: 'Web', icon: 'mdi-web' },
          { value: 'ecrag', text: 'ECSP', icon: 'mdi-atom-variant' },
        ]
      };
    },
    computed: {
      currentStrategy() {
        return this.ragStrategies.find(s => s.value === this.rag_strategy).text;
      },
      ragStrategyIcon() {
        return this.ragStrategies.find(s => s.value === this.rag_strategy).icon;
      },
      strategyColor() {
        const colors = {
          ecrag: 'primary',
          web_search: 'success',
          llm_passthrough: 'warning'  // Changed 'tips' to 'warning' for standard Vuetify
        };
        return colors[this.rag_strategy];
      },
      strategyTextColor() {
        return 'black';
      }
    },
    methods: {
      toggleMenu() {
        this.isMenuOpen = !this.isMenuOpen;
      },
      handleStrategySelect(strategy) {
        if (strategy.value === 'ecrag') {
          // Create anticipation for ECRAG
          this.$emit('ecrag-clicked');
          this.$toast.info('ECRAG coming soon!', {
            position: 'top-right',
            duration: 3000
          });
          this.isMenuOpen = false;
          return;
        }

        // Update the strategy
        this.rag_strategy = strategy.value;

        // Emit event to parent component
        this.$emit('strategy-changed', this.rag_strategy);

        // Close the menu
        this.isMenuOpen = false;
      },
      updateRAGStrategy() {
        // This would be implemented in the parent component
        this.$emit('update-strategy', this.rag_strategy);
      }
    }
  };
  </script>

  <style scoped>
  .rag-strategy-menu {
    display: inline-flex;
    align-items: center;
  }
  .strategy-chip {
    cursor: pointer;
  }
  </style>
